<template>
    <div id="modalOptions" v-show="showModal"
    :style="{
      background: colors.theme == 'dark' ? '#000' : '#fff'
    }"
    >
        <img class="img-error" v-show="error" src="/img/icons/failed-extract-icon.png" alt="">
        <!-- <img class="img-surrender"  :src="`/img/icons/enigma-red-${currentEnigma}.png`" alt=""> -->
        <h3
        :style="{
          color: colors.theme == 'dark' ? '#fff' : '#000'
        }">{{modalTitle}}</h3>
        <span
        :style="{
          color: colors.theme == 'dark' ? '#fff' : '#000'
        }">{{modalSubtitle}}</span>
        <div class="btn btn_ok" v-if="!justBack" :class="{'multiple': multiple}" @click="giveUp()">
            <span v-show="!surrending">{{titleBtnOk}}</span>
            <game-loader v-show="surrending" loaderStyle="bullets"></game-loader>
        </div>
        <div class="btn btn_cancel" v-if="multiple || justBack" @click="modalOff()"><span>{{titleBtnCancel}}</span></div>
  </div>
</template>

<script>
import { Bus } from './../../../event-bus.js'
import Loader from './Loader';
import EnigmaIndex1 from '../customIcons/enigmasIndexPuzzleIcon/Index1';
import EnigmaIndex2 from '../customIcons/enigmasIndexPuzzleIcon/Index2';
import EnigmaIndex3 from '../customIcons/enigmasIndexPuzzleIcon/Index3';
import EnigmaIndex4 from '../customIcons/enigmasIndexPuzzleIcon/Index4';
export default {
    name: 'ModalWithOptions',
    components:{
        'game-loader': Loader,
        EnigmaIndex1,EnigmaIndex2,EnigmaIndex3,EnigmaIndex4
  },
  props: {
    showModal: {
      type: Boolean,
      default: true
    },
    modalTitle: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    },
    titleBtnOk: {
      type: String,
      default: "Sim"
    },
    titleBtnCancel: {
      type: String,
      default: "Não"
    },
    last_id: {
      type: String
    },
    modalSubtitle: {
      type: String,
      default: ""
    },
    surrending: {
      type: Boolean,
      default: false
    },
    surrender: {
      type: Boolean,
      default: false
    },
    currentEnigma: {
      type: Number,
      required: false
    },
    error: {
      type: Boolean,
      default: false
    },
    justBack: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    hideModal: "",
     colors:{}
    // currentEnigma: localStorage.getItem('SoloGameSize')
  }),

  methods: {
    modalOff() {
      this.$emit("hideModal", (this.hideModal = true));
    },
    async giveUp() {
      Bus.$emit("modalEvent");
    }
  },
  created() {
    // console.log("CURRENT :", this.currentEnigma);
    this.colors = JSON.parse(localStorage.getItem("colors"));
  }
};
</script>

<style lang="scss" scoped>
#modalOptions {
  height: 100%;
  z-index: 8;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: #fff;

        .img-error{
            margin: 5% 0;
        }
        .img-surrender{
            margin: 0 0 15px 0;
            width: 140px;
        }

  h3,
  > span {
    color: rgb(124, 130, 134);
    letter-spacing: 2px;
  }
  > span {
    font-size: 13px;
    font-weight: 700;
  }

  h3 {
    font-size: 21px;
    font-weight: 900;
    word-break: inherit;
    text-transform: uppercase;
  }

  span {
    padding-top: 10px;
    margin: 1% 0;
  }

  .btn {
    // background-color: #FFF581;
    // border-bottom: 6px solid rgba($color: #B5004A, $alpha: 1.0);
    min-width: 60%;
    padding: 20px;
    text-transform: uppercase;
    text-align: center;
    margin: 32px auto 0;
    font-weight: 900;
    letter-spacing: 3px;
    -webkit-box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.1);
    transition: border-bottom 0.2s;
    border-radius: 50px;

    &:active {
      border-bottom: none;
    }
  }

  .btn_ok {
    background-color: #fff581;
    border-bottom: 6px solid rgba($color: #fff581, $alpha: 1);
  }
  .btn_cancel {
    background-color: #2f353a;
    border-bottom: 6px solid rgba($color: #000000, $alpha: 1);
    color: #fff;
    margin: 15px auto 0;
  }
  .multiple.btn_ok {
    background-color: #ff0062;
    border-bottom: 6px solid rgba($color: #b5004a, $alpha: 1);
    color: #fff;
  }
}

@media screen and (min-width: 600px) {
  #modalOptions {
    .btn {
      min-width: 30%;
    }
  }
}
</style>
